export default __webpack_public_path__ + "static/sad-e2368c52a88343b738027c40c3a70c1c.png";